import React from 'react'
import * as Sentry from '@sentry/react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { PostHogProvider } from '@posthog/react'
import posthog, { initPostHog } from '@/lib/analytics/posthog'
import App from './App.tsx'
import './index.css'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
})

// Initialize PostHog for production only (no-op in development)
initPostHog()

const container = document.getElementById('root')!
const app = (
  <HelmetProvider>
    <PostHogProvider client={posthog}>
      <Sentry.ErrorBoundary
        fallback={<span>Something went wrong</span>}
        onError={(error, componentStack) => {
          try {
            (posthog as any).captureException?.(error, { componentStack });
          } catch {}
        }}
      >
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </Sentry.ErrorBoundary>
    </PostHogProvider>
  </HelmetProvider>
)

// Use hydrate for prerendered pages, createRoot for dynamic pages
if (container.hasChildNodes()) {
  hydrateRoot(container, app)
} else {
  createRoot(container).render(app)
}
